export function parseError(err: any, defaultMessage?: string): string {
  if (!err) {
    return 'Unknown error';
  }

  if (!err.message) {
    return `${err}`;
  }

  try {
    const parsed = JSON.parse(err.message);
    if (parsed.message) {
      let { message, errors } = parsed;
      if (Array.isArray(errors)) {
        message = message + '\n' + errors.map((e: any) => String(e)).join('\n');
      }

      return message;
    }
  } catch (innerErr) {
    // ignore
  }
  return defaultMessage || `${err.message}`;
}
